var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 65,
    rx: 40,
    ry: 14.5,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2864 76.3787L63.9877 62.6947C64.1469 62.6103 64.28 62.4841 64.3729 62.3297C64.4657 62.1753 64.5148 61.9985 64.5148 61.8183C64.5148 61.6381 64.4657 61.4614 64.3729 61.307C64.28 61.1526 64.1469 61.0264 63.9877 60.9419L40.284 47.2579C40.1204 47.175 39.9396 47.1318 39.7562 47.1318C39.5728 47.1318 39.392 47.175 39.2284 47.2579L15.527 60.9321C15.3679 61.0166 15.2348 61.1428 15.1419 61.2972C15.0491 61.4516 15 61.6284 15 61.8086C15 61.9887 15.0491 62.1655 15.1419 62.3199C15.2348 62.4743 15.3679 62.6005 15.527 62.685L39.2308 76.369C39.3936 76.4534 39.574 76.4982 39.7574 76.4999C39.9408 76.5016 40.1221 76.4601 40.2864 76.3787Z",
    fill: "url(#paint0_linear_803_9517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2864 76.3787L63.9877 62.6947C64.1469 62.6103 64.28 62.4841 64.3729 62.3297C64.4657 62.1753 64.5148 61.9985 64.5148 61.8183C64.5148 61.6381 64.4657 61.4614 64.3729 61.307C64.28 61.1526 64.1469 61.0264 63.9877 60.9419L40.284 47.2579C40.1204 47.175 39.9396 47.1318 39.7562 47.1318C39.5728 47.1318 39.392 47.175 39.2284 47.2579L15.527 60.9321C15.3679 61.0166 15.2348 61.1428 15.1419 61.2972C15.0491 61.4516 15 61.6284 15 61.8086C15 61.9887 15.0491 62.1655 15.1419 62.3199C15.2348 62.4743 15.3679 62.6005 15.527 62.685L39.2308 76.369C39.3936 76.4534 39.574 76.4982 39.7574 76.4999C39.9408 76.5016 40.1221 76.4601 40.2864 76.3787Z",
    fill: "url(#paint1_linear_803_9517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2864 76.3787L63.9877 62.6947C64.1469 62.6103 64.28 62.4841 64.3729 62.3297C64.4657 62.1753 64.5148 61.9985 64.5148 61.8183C64.5148 61.6381 64.4657 61.4614 64.3729 61.307C64.28 61.1526 64.1469 61.0264 63.9877 60.9419L40.284 47.2579C40.1204 47.175 39.9396 47.1318 39.7562 47.1318C39.5728 47.1318 39.392 47.175 39.2284 47.2579L15.527 60.9321C15.3679 61.0166 15.2348 61.1428 15.1419 61.2972C15.0491 61.4516 15 61.6284 15 61.8086C15 61.9887 15.0491 62.1655 15.1419 62.3199C15.2348 62.4743 15.3679 62.6005 15.527 62.685L39.2308 76.369C39.3936 76.4534 39.574 76.4982 39.7574 76.4999C39.9408 76.5016 40.1221 76.4601 40.2864 76.3787Z",
    fill: "url(#paint2_linear_803_9517)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.2864 76.3787L63.9877 62.6947C64.1469 62.6103 64.28 62.4841 64.3729 62.3297C64.4657 62.1753 64.5148 61.9985 64.5148 61.8183C64.5148 61.6381 64.4657 61.4614 64.3729 61.307C64.28 61.1526 64.1469 61.0264 63.9877 60.9419L40.284 47.2579C40.1204 47.175 39.9396 47.1318 39.7562 47.1318C39.5728 47.1318 39.392 47.175 39.2284 47.2579L15.527 60.9321C15.3679 61.0166 15.2348 61.1428 15.1419 61.2972C15.0491 61.4516 15 61.6284 15 61.8086C15 61.9887 15.0491 62.1655 15.1419 62.3199C15.2348 62.4743 15.3679 62.6005 15.527 62.685L39.2308 76.369C39.3936 76.4534 39.574 76.4982 39.7574 76.4999C39.9408 76.5016 40.1221 76.4601 40.2864 76.3787Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.527 61.5514L39.2308 75.2353C39.3944 75.3182 39.5752 75.3614 39.7586 75.3614C39.942 75.3614 40.1228 75.3182 40.2864 75.2353L63.9877 61.5514C64.0514 61.5298 64.1067 61.4887 64.1459 61.4341C64.1851 61.3794 64.2061 61.3139 64.2061 61.2466C64.2061 61.1794 64.1851 61.1138 64.1459 61.0592C64.1067 61.0045 64.0514 60.9635 63.9877 60.9419L40.284 47.2579C40.1204 47.175 39.9396 47.1318 39.7562 47.1318C39.5728 47.1318 39.3919 47.175 39.2284 47.2579L15.527 60.9321C15.4596 60.9512 15.4003 60.9918 15.3581 61.0477C15.3158 61.1036 15.293 61.1717 15.293 61.2417C15.293 61.3118 15.3158 61.3799 15.3581 61.4358C15.4003 61.4917 15.4596 61.5323 15.527 61.5514Z",
    fill: "url(#paint3_linear_803_9517)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7192 70.3936L60.553 60.6736V20.0801L43.7192 29.8V70.3936Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7572 73.2532V32.0868L18.9619 20.0801V61.2465L39.7572 73.2532Z",
    fill: "url(#paint4_linear_803_9517)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 56.1003L18.9625 44.0936V42.9502L16.9805 44.0936L39.7578 57.2436V56.1003Z",
    fill: "url(#paint5_linear_803_9517)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.7578 56.1003L18.9625 44.0936V42.9502L16.9805 44.0936L39.7578 57.2436V56.1003Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9805 44.0935L39.7578 57.2436V58.3869L16.9805 45.2369V44.0935Z",
    fill: "url(#paint6_linear_803_9517)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 56.1002L43.7189 53.8135L44.7087 54.3864L39.7573 57.2436V56.1002Z",
    fill: "url(#paint7_linear_803_9517)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.7573 56.1002L43.7189 53.8135L44.7087 54.3864L39.7573 57.2436V56.1002Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 58.3868L44.7087 55.5296V54.3862L39.7573 57.2435V58.3868Z",
    fill: "url(#paint8_linear_803_9517)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.7573 58.3868L44.7087 55.5296V54.3862L39.7573 57.2435V58.3868Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 32.0868L43.7189 29.8V53.8134L39.7573 56.1002V32.0868Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 58.3869L43.7189 56.1001V70.9664L39.7573 73.2532V58.3869Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7775 52.6701V46.9533L33.8159 44.6665V50.3834L37.7775 52.6701Z",
    fill: "url(#paint9_linear_803_9517)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.7775 52.6701V46.9533L33.8159 44.6665V50.3834L37.7775 52.6701Z",
    fill: "#F7E21E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8159 50.3834L34.8057 49.8129V45.237L33.8159 44.6665V50.3834Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7775 51.5268L34.8057 49.813L33.8159 50.3835L37.7775 52.6702V51.5268Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8342 49.2401V43.5232L26.8828 40.6636V46.3805L31.8342 49.2401Z",
    fill: "url(#paint10_linear_803_9517)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.8342 49.2401V43.5232L26.8828 40.6636V46.3805L31.8342 49.2401Z",
    fill: "#F7E21E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8726 45.81L27.875 41.2365L26.8828 40.6636V46.3805L27.8726 45.81Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8342 48.0966V49.2399L26.8828 46.3803L27.8726 45.8098L31.8342 48.0966Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 64.9621V59.2452L51.1447 56.3879V62.1048L46.1934 64.9621Z",
    fill: "url(#paint11_linear_803_9517)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1548 61.5319V56.9584L51.1446 56.3879V62.1048L50.1548 61.5319Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 63.8187V64.9621L51.1447 62.1049L50.155 61.532L46.1934 63.8187Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 55.4347V49.7178L51.1447 46.8582V52.575L46.1934 55.4347Z",
    fill: "url(#paint12_linear_803_9517)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1548 52.0046V47.4286L51.1446 46.8582V52.575L50.1548 52.0046Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 54.2914V55.4348L51.1447 52.5751L50.155 52.0046L46.1934 54.2914Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 45.9049V40.188L51.1447 37.3284V43.0453L46.1934 45.9049Z",
    fill: "url(#paint13_linear_803_9517)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1548 42.4748V37.9013L51.1446 37.3284V43.0453L50.1548 42.4748Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 44.7619V45.9052L51.1447 43.0456L50.155 42.4751L46.1934 44.7619Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 36.3751V30.6582L51.1447 27.7986V33.5179L46.1934 36.3751Z",
    fill: "url(#paint14_linear_803_9517)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1548 32.945V28.3715L51.1446 27.7986V33.5179L50.1548 32.945Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1934 35.2316V36.375L51.1447 33.5177L50.155 32.9448L46.1934 35.2316Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 60.8981V55.1812L58.1877 52.324L58.1853 58.0409L53.2339 60.8981Z",
    fill: "url(#paint15_linear_803_9517)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1958 57.468V52.8944L58.188 52.324L58.1856 58.0409L57.1958 57.468Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 59.757V60.8979L58.1853 58.0407L57.1955 57.4678L53.2339 59.757Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 51.3707V45.6514L58.1877 42.7942L58.1853 48.5111L53.2339 51.3707Z",
    fill: "url(#paint16_linear_803_9517)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1958 47.9406V43.3647L58.188 42.7942L58.1856 48.5111L57.1958 47.9406Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 50.2272V51.3706L58.1853 48.5109L57.1955 47.9404L53.2339 50.2272Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 41.841V36.1241L58.1877 33.2644L58.1853 38.9837L53.2339 41.841Z",
    fill: "url(#paint17_linear_803_9517)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1958 38.4108V33.8373L58.188 33.2644L58.1856 38.9837L57.1958 38.4108Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 40.6974V41.8408L58.1853 38.9836L57.1955 38.4106L53.2339 40.6974Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 32.3112V26.5943L58.1877 23.7371L58.1853 29.454L53.2339 32.3112Z",
    fill: "url(#paint18_linear_803_9517)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1958 28.881V24.3075L58.188 23.7371L58.1856 29.454L57.1958 28.881Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 31.1679V32.3112L58.1853 29.454L57.1955 28.8811L53.2339 31.1679Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9035 45.237V39.5202L20.9419 37.2334V42.9503L24.9035 45.237Z",
    fill: "url(#paint19_linear_803_9517)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.9035 45.237V39.5202L20.9419 37.2334V42.9503L24.9035 45.237Z",
    fill: "#F7E21E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9317 42.3798L20.9419 42.9503V37.2334L21.9317 37.8063V42.3798Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9035 44.0935L21.9317 42.3796L20.9419 42.9501L24.9035 45.2369V44.0935Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8828 56.1562C26.8828 54.5423 27.9921 53.8719 29.3597 54.6618C30.7274 55.4517 31.8342 57.3996 31.8342 59.0159V68.6797L26.8828 65.8201V56.1562Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8341 59.016C31.8341 57.3996 30.7273 55.4493 29.3596 54.6619C29.0114 54.4412 28.6064 54.3269 28.1943 54.3327C27.968 54.7104 27.857 55.1459 27.8749 55.5858V65.2497L31.8341 67.5364V59.016Z",
    fill: "#455A64"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8341 59.016C31.8341 57.3996 30.7273 55.4493 29.3596 54.6619C29.0114 54.4412 28.6064 54.3269 28.1943 54.3327C27.968 54.7104 27.857 55.1459 27.8749 55.5858V65.2497L31.8341 67.5364V59.016Z",
    fill: "url(#paint20_linear_803_9517)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.8341 59.016C31.8341 57.3996 30.7273 55.4493 29.3596 54.6619C29.0114 54.4412 28.6064 54.3269 28.1943 54.3327C27.968 54.7104 27.857 55.1459 27.8749 55.5858V65.2497L31.8341 67.5364V59.016Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.074 55.2006C29.922 55.0572 29.7589 54.926 29.5864 54.8081V57.3777L27.8799 56.3879V56.9803L29.5864 57.9725V65.3813L30.074 65.6617V58.2504L31.8342 59.267V59.0232C31.8342 58.9062 31.8342 58.7795 31.8171 58.6697L30.074 57.6653V55.2006Z",
    fill: "#455A64"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 32.0869V28.6567L17.9697 16.0796V19.5097L39.7573 32.0869Z",
    fill: "url(#paint21_linear_803_9517)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.7573 32.0869V28.6567L17.9697 16.0796V19.5097L39.7573 32.0869Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 32.0869V28.6567L61.5449 16.0796V19.5097L39.7573 32.0869Z",
    fill: "url(#paint22_linear_803_9517)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.7573 32.0869V28.6567L61.5449 16.0796V19.5097L39.7573 32.0869Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9419 25.9483C20.9419 24.6025 21.8293 24.0223 22.9215 24.6537C24.0137 25.2852 24.9035 26.8893 24.9035 28.235V37.2333L20.9419 34.9466V25.9483Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9213 24.6513C22.6857 24.5101 22.4201 24.4265 22.1461 24.4075C21.9953 24.7099 21.9216 25.0449 21.9316 25.3826V34.3809L24.9034 36.0875V28.2325C24.9034 26.8868 24.016 25.2827 22.9213 24.6513Z",
    fill: "url(#paint23_linear_803_9517)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9213 24.6513C22.6857 24.5101 22.4201 24.4265 22.1461 24.4075C21.9953 24.7099 21.9216 25.0449 21.9316 25.3826V34.3809L24.9034 36.0875V28.2325C24.9034 26.8868 24.016 25.2827 22.9213 24.6513Z",
    fill: "#F7E21E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9419 34.9464L21.9317 34.3735L24.9035 36.0874V37.2332L20.9419 34.9464Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8828 29.8661C26.8828 28.2498 27.9921 27.5818 29.3597 28.3717C30.7274 29.1616 31.8342 31.1095 31.8342 32.7258V41.2365L26.8828 38.3769V29.8661Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8341 32.7257C31.8341 31.1093 30.7273 29.159 29.3596 28.3716C29.0114 28.151 28.6064 28.0366 28.1943 28.0425C27.968 28.4201 27.857 28.8556 27.8749 29.2955V37.8038L31.8341 40.093V32.7257Z",
    fill: "url(#paint24_linear_803_9517)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.8341 32.7257C31.8341 31.1093 30.7273 29.159 29.3596 28.3716C29.0114 28.151 28.6064 28.0366 28.1943 28.0425C27.968 28.4201 27.857 28.8556 27.8749 29.2955V37.8038L31.8341 40.093V32.7257Z",
    fill: "#F7E21E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 37.8037L26.8828 38.3766L31.8342 41.2363V40.0929L27.875 37.8037Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8159 33.3838C33.8159 32.0381 34.7009 31.4579 35.7955 32.0893C36.8901 32.7207 37.7775 34.3249 37.7775 35.6706V44.6689L33.8159 42.3821V33.3838Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7954 32.0871C35.5597 31.9462 35.2941 31.8627 35.0202 31.8433C34.869 32.1455 34.7953 32.4806 34.8056 32.8184V41.8167L37.7775 43.5233V35.6683C37.7775 34.3226 36.8901 32.7185 35.7954 32.0871Z",
    fill: "url(#paint25_linear_803_9517)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.7954 32.0871C35.5597 31.9462 35.2941 31.8627 35.0202 31.8433C34.869 32.1455 34.7953 32.4806 34.8056 32.8184V41.8167L37.7775 43.5233V35.6683C37.7775 34.3226 36.8901 32.7185 35.7954 32.0871Z",
    fill: "#F7E21E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8057 41.8066L33.8159 42.3795L37.7775 44.6663V43.5229L34.8057 41.8066Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8159 59.6719C33.8159 58.3262 34.7009 57.746 35.7955 58.3774C36.8901 59.0088 37.7775 60.6129 37.7775 61.9587V72.1101L33.8159 69.8233V59.6719Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7959 58.3771C35.5601 58.2362 35.2945 58.1527 35.0206 58.1333C34.8698 58.4357 34.7961 58.7707 34.8061 59.1085V69.2575L37.7779 70.964V61.9437C37.7779 60.6127 36.8905 59.0085 35.7959 58.3771Z",
    fill: "url(#paint26_linear_803_9517)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.7959 58.3771C35.5601 58.2362 35.2945 58.1527 35.0206 58.1333C34.8698 58.4357 34.7961 58.7707 34.8061 59.1085V69.2575L37.7779 70.964V61.9437C37.7779 60.6127 36.8905 59.0085 35.7959 58.3771Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8159 69.8232V66.3931L37.7775 68.6798V72.11L33.8159 69.8232Z",
    fill: "#1A1A1A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8159 66.3932L34.8057 65.8203L37.7751 67.5366L37.7775 68.68L33.8159 66.3932Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9419 52.2388C20.9419 50.8931 21.8293 50.3129 22.9215 50.9443C24.0137 51.5757 24.9035 53.1798 24.9035 54.5256V64.677L20.9419 62.3951V52.2388Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9213 50.9369C22.6853 50.7968 22.4199 50.7133 22.1461 50.6931C21.9953 50.9955 21.9216 51.3305 21.9316 51.6683V61.8197L24.9034 63.5263V54.506C24.9034 53.1773 24.016 51.5732 22.9213 50.9369Z",
    fill: "url(#paint27_linear_803_9517)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9213 50.9369C22.6853 50.7968 22.4199 50.7133 22.1461 50.6931C21.9953 50.9955 21.9216 51.3305 21.9316 51.6683V61.8197L24.9034 63.5263V54.506C24.9034 53.1773 24.016 51.5732 22.9213 50.9369Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9035 64.6768V61.2467L20.9419 58.96V62.3901L24.9035 64.6768Z",
    fill: "#1A1A1A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9419 58.9599L21.9317 58.387L24.9035 60.1033V61.2466L20.9419 58.9599Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8828 65.8201V64.6768L31.8342 67.5364V68.6798L26.8828 65.8201Z",
    fill: "#1A1A1A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8828 64.6769L27.875 64.1064L31.8342 66.3932V67.5366L26.8828 64.6769Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 28.6567L61.5448 16.0796L39.7573 3.5L17.9697 16.0796L39.7573 28.6567Z",
    fill: "url(#paint28_linear_803_9517)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.7573 28.6567L61.5448 16.0796L39.7573 3.5L17.9697 16.0796L39.7573 28.6567Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7571 26.3699L57.5831 16.0795L39.7571 5.78662L21.9312 16.0795L39.7571 26.3699Z",
    fill: "url(#paint29_linear_803_9517)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7571 5.78662V9.21919L24.903 17.7933L21.9312 16.0795L39.7571 5.78662Z",
    fill: "url(#paint30_linear_803_9517)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.7571 5.78662V9.21919L24.903 17.7933L21.9312 16.0795L39.7571 5.78662Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 5.78662L57.5833 16.0795L54.6115 17.7933L39.7573 9.21919V5.78662Z",
    fill: "url(#paint31_linear_803_9517)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.7573 5.78662L57.5833 16.0795L54.6115 17.7933L39.7573 9.21919V5.78662Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7854 8.64673L31.834 11.5064L38.7674 15.507L43.7188 12.6498L36.7854 8.64673Z",
    fill: "#455A64"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M31.834 11.5061V14.9362L38.7674 18.9368V15.5067L31.834 11.5061Z",
    fill: "#1A1A1A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.719 12.6494V16.0795L38.7676 18.9368V15.5066L43.719 12.6494Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1596 10.5651C34.26 11.0844 34.26 11.9255 35.1596 12.4447C35.6638 12.7008 36.2213 12.8343 36.7869 12.8343C37.3524 12.8343 37.9099 12.7008 38.4142 12.4447C39.3113 11.9255 39.3113 11.0844 38.4142 10.5651C37.9099 10.309 37.3524 10.1755 36.7869 10.1755C36.2213 10.1755 35.6638 10.309 35.1596 10.5651Z",
    fill: "#1A1A1A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0253 11.1014C35.6035 11.3232 35.6035 11.6865 36.0253 11.9083C36.264 12.0191 36.524 12.0766 36.7871 12.0766C37.0503 12.0766 37.3103 12.0191 37.549 11.9083C37.9683 11.6865 37.9683 11.3232 37.549 11.1014C37.3103 10.9905 37.0503 10.9331 36.7871 10.9331C36.524 10.9331 36.264 10.9905 36.0253 11.1014Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2988 15.7651L41.2886 16.3356V18.6248",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7373 14.936L42.7271 15.5065V17.7933",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_9517",
    x1: 39.7574,
    y1: 47.1318,
    x2: 39.7574,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_9517",
    x1: 39.7574,
    y1: 47.1318,
    x2: 39.7574,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_803_9517",
    x1: 39.7574,
    y1: 47.1318,
    x2: 39.7574,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_803_9517",
    x1: 39.7495,
    y1: 47.1318,
    x2: 39.7495,
    y2: 75.3614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_803_9517",
    x1: 29.3596,
    y1: 20.0801,
    x2: 29.3596,
    y2: 73.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_803_9517",
    x1: 28.3691,
    y1: 42.9502,
    x2: 28.3691,
    y2: 57.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_803_9517",
    x1: 28.3691,
    y1: 44.0935,
    x2: 28.3691,
    y2: 58.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_803_9517",
    x1: 42.233,
    y1: 53.8135,
    x2: 42.233,
    y2: 57.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_803_9517",
    x1: 42.233,
    y1: 54.3862,
    x2: 42.233,
    y2: 58.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_803_9517",
    x1: 35.7967,
    y1: 44.6665,
    x2: 35.7967,
    y2: 52.6701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_803_9517",
    x1: 29.3585,
    y1: 40.6636,
    x2: 29.3585,
    y2: 49.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_803_9517",
    x1: 48.6691,
    y1: 56.3879,
    x2: 48.6691,
    y2: 64.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_803_9517",
    x1: 48.6691,
    y1: 46.8582,
    x2: 48.6691,
    y2: 55.4347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_803_9517",
    x1: 48.6691,
    y1: 37.3284,
    x2: 48.6691,
    y2: 45.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_803_9517",
    x1: 48.6691,
    y1: 27.7986,
    x2: 48.6691,
    y2: 36.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_803_9517",
    x1: 55.7108,
    y1: 52.324,
    x2: 55.7108,
    y2: 60.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_803_9517",
    x1: 55.7108,
    y1: 42.7942,
    x2: 55.7108,
    y2: 51.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_803_9517",
    x1: 55.7108,
    y1: 33.2644,
    x2: 55.7108,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_803_9517",
    x1: 55.7108,
    y1: 23.7371,
    x2: 55.7108,
    y2: 32.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_803_9517",
    x1: 22.9227,
    y1: 37.2334,
    x2: 22.9227,
    y2: 45.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_803_9517",
    x1: 29.8536,
    y1: 54.3325,
    x2: 29.8536,
    y2: 67.5364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_803_9517",
    x1: 28.8635,
    y1: 16.0796,
    x2: 28.8635,
    y2: 32.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_803_9517",
    x1: 50.6511,
    y1: 16.0796,
    x2: 50.6511,
    y2: 32.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_803_9517",
    x1: 23.417,
    y1: 24.4075,
    x2: 23.417,
    y2: 36.0875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_803_9517",
    x1: 29.8536,
    y1: 28.0422,
    x2: 29.8536,
    y2: 40.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_803_9517",
    x1: 36.2911,
    y1: 31.8433,
    x2: 36.2911,
    y2: 43.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_803_9517",
    x1: 36.2915,
    y1: 58.1333,
    x2: 36.2915,
    y2: 70.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_803_9517",
    x1: 23.417,
    y1: 50.6931,
    x2: 23.417,
    y2: 63.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_803_9517",
    x1: 39.7573,
    y1: 3.5,
    x2: 39.7573,
    y2: 28.6567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_803_9517",
    x1: 39.7571,
    y1: 5.78662,
    x2: 39.7571,
    y2: 26.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_803_9517",
    x1: 30.8441,
    y1: 5.78662,
    x2: 30.8441,
    y2: 17.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_803_9517",
    x1: 48.6703,
    y1: 5.78662,
    x2: 48.6703,
    y2: 17.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.a00c8d2eb17c093f6555a0bf771d7419.svg";
export { ForwardRef as ReactComponent };